import conversationTypes from './conversations.types';

export const fetchConversationsStart = (timespan) => ({
  type: conversationTypes.FETCH_CONVERSATIONS_START,
  payload: {
    ...timespan,
  },
});

export const fetchChatsStart = (timespan) => ({
  type: conversationTypes.FETCH_CHATS_START,
  payload: {
    ...timespan,
  },
});


export const setConversations = (conversations) => ({
  type: conversationTypes.SET_CONVERSATIONS,
  payload: conversations,
});

export const setConversationsCount = (conversationsCount) => ({
  type: conversationTypes.SET_CONVERSATIONS_COUNT,
  payload: conversationsCount,
});

export const setAgentStartedConversations = (conversationsCount) => ({
  type: conversationTypes.SET_AGENT_STARTED_CONVERSATIONS_COUNT,
  payload: conversationsCount,
});

export const setChats = (chats , status) => ({
  type: conversationTypes.SET_CHATS,
  payload: {
    chats,
    status
  },
});

export const loadingConversations = () => ({
  type: conversationTypes.LOADING_CONVERSATIONS,
});

export const loadingChats = (value) => ({
  type: conversationTypes.LOADING_CHATS,
  payload: value,
});

